import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import AskAiDrawer from './AskAiDrawer';
import { AskAiIcon } from './icons/AskAiIcon';

const useStyles = createUseStyles({
    askAiContainer: {
        background: 'none',
        border: 'none',
        font: 'inherit',
        color: 'inherit',
        outline: 'inherit',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '0px 5px',
        borderRadius: '4px',
        justifyContent: 'right',
    },
    askAiIcon: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '16px',
    },
    askAiText: {
        fontWeight: 500,
        fontSize: '14px',
    },
});

interface AskAiButtonProps {
    context?: any;
}

export const AskAiButton: React.FC<AskAiButtonProps> = ({ context }) => {
    const classes = useStyles();
    const [isAiDrawerVisible, setIsAiDrawerVisible] = useState(false);

    const toggleAiDrawer = () => {
        setIsAiDrawerVisible(!isAiDrawerVisible);
    };

    return (
        <>
            <button className={classes.askAiContainer} onClick={toggleAiDrawer}>
                <div className={classes.askAiIcon}>
                    <AskAiIcon />
                </div>
                <div className={classes.askAiText}>
                    Ask AI
                </div>
            </button>
            {isAiDrawerVisible && (
                <AskAiDrawer 
                    visible={isAiDrawerVisible} 
                    onClose={toggleAiDrawer} 
                    context={context} 
                />
            )}
        </>
    );
};
